import { AsideRow } from "@/components/settings/settings-kit";
import { PLACEMENT_LABEL } from "@/components/content-programs/media-tile";
import { resolveConstraintsFromConfig, type ContentProgramConfig } from "@/config/contentProgramUpload";

function formatList(mimes: string[], prefix: string) {
  return mimes
    .map((m) => (m === "video/quicktime" ? "MOV" : m.replace(prefix, "").toUpperCase()))
    .join(", ");
}

/** What the brand accepts, as quiet fact rows for the submit page's aside. */
export default function ContentRequirementsPanel({ config }: { config: ContentProgramConfig | null | undefined }) {
  const resolved = resolveConstraintsFromConfig(config);
  const types = config?.allowedMediaTypes ?? ["IMAGE", "VIDEO"];
  const image = types.includes("IMAGE");
  const video = types.includes("VIDEO");
  const ratios = config?.allowedAspectRatios ?? [];

  return (
    <>
      <AsideRow label="Media">{image && video ? "Images and videos" : video ? "Videos" : "Images"}</AsideRow>
      <AsideRow label="Placements">
        {ratios.length
          ? ratios.map((r) => `${r} ${PLACEMENT_LABEL[r].toLowerCase()}`).join(", ")
          : "Any Meta placement"}
      </AsideRow>
      {image && <AsideRow label="Image size">Up to {resolved.maxImageMb} MB</AsideRow>}
      {video && <AsideRow label="Video size">Up to {resolved.maxVideoMb} MB</AsideRow>}
      {video && resolved.maxVideoDurationSeconds && (
        <AsideRow label="Video length">Up to {resolved.maxVideoDurationSeconds} seconds</AsideRow>
      )}
      {(resolved.minResolutionWidth || resolved.minResolutionHeight) && (
        <AsideRow label="Minimum size">
          {resolved.minResolutionWidth && resolved.minResolutionHeight
            ? `${resolved.minResolutionWidth}×${resolved.minResolutionHeight}`
            : resolved.minResolutionWidth
              ? `${resolved.minResolutionWidth} wide`
              : `${resolved.minResolutionHeight} tall`}
        </AsideRow>
      )}
      {image && <AsideRow label="Image formats">{formatList(resolved.allowedImageMimes, "image/")}</AsideRow>}
      {video && <AsideRow label="Video formats">{formatList(resolved.allowedVideoMimes, "video/")}</AsideRow>}
    </>
  );
}
